import 'babel-polyfill'
import Phaser from 'phaser'

import LoadingScene from './scenes/loading'

const DEFAULT_WIDTH = 1280
const DEFAULT_HEIGHT = 720
const MAX_WIDTH = 1600
const MAX_HEIGHT = 1100
const SCALE_MODE = 'SMOOTH' // FIT OR SMOOTH

const config = {
  title: 'the LOOKAHEAD',
  url: '',
  parent: 'game',
  input: {
    activePointers: 4
  },
  dom: {
    createContainer: true
  },
  type: Phaser.WEBGL,
  physics: {
    default: 'arcade',
    arcade: {
      debug: false, // process.env.NODE_ENV !== 'production',
      gravity: { y: 0 }
    }
  },
  scale: {
    parent: 'game',
    mode: Phaser.Scale.NONE,
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT
  },
  backgroundColor: '#222223',
  banner: false
}

export default class Game extends Phaser.Game {
  start () {
    super.start()
    this.input.keyboard.addCapture('SPACE') // to prevent the page from scrolling

    const muted = window.localStorage.getItem('sound') === 'mute'
    this.sound.setMute(muted)

    this.scene.add('LoadingScene', LoadingScene, true)

    // from: https://github.com/yandeu/phaser3-scaling-resizing-example
    const resize = () => {
      const w = window.innerWidth
      const h = window.innerHeight

      const width = DEFAULT_WIDTH
      const height = DEFAULT_HEIGHT
      const maxWidth = MAX_WIDTH
      const maxHeight = MAX_HEIGHT
      const scaleMode = SCALE_MODE

      const scale = Math.min(w / width, h / height)
      const newWidth = Math.min(w / scale, maxWidth)
      const newHeight = Math.min(h / scale, maxHeight)

      const defaultRatio = DEFAULT_WIDTH / DEFAULT_HEIGHT
      const maxRatioWidth = MAX_WIDTH / DEFAULT_HEIGHT
      const maxRatioHeight = DEFAULT_WIDTH / MAX_HEIGHT

      // smooth scaling
      let smooth = 1
      if (scaleMode === 'SMOOTH') {
        const maxSmoothScale = 1.15
        const normalize = (value, min, max) => {
          return (value - min) / (max - min)
        }
        if (width / height < w / h) {
          smooth =
          -normalize(newWidth / newHeight, defaultRatio, maxRatioWidth) / (1 / (maxSmoothScale - 1)) + maxSmoothScale
        } else {
          smooth =
          -normalize(newWidth / newHeight, defaultRatio, maxRatioHeight) / (1 / (maxSmoothScale - 1)) + maxSmoothScale
        }
      }

      // resize the game
      this.scale.resize(newWidth * smooth, newHeight * smooth)

      // scale the width and height of the css
      this.canvas.style.width = newWidth * scale + 'px'
      this.canvas.style.height = newHeight * scale + 'px'

      // center the game with css margin
      this.canvas.style.marginTop = `${(h - newHeight * scale) / 2}px`
      this.canvas.style.marginLeft = `${(w - newWidth * scale) / 2}px`
    }
    window.addEventListener('resize', event => {
      resize()
    })
    resize()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const game = new Game(config)
  if (process.env.NODE_ENV !== 'production') {
    window.game = game
  }
})

if (module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.dispose(() => {
    if (window.game) {
      const manager = window.game.scene
      console.log('Hot reload dispose, removing these scenes:')
      manager.dump()
      Object.keys(manager.keys).forEach(s => manager.remove(s))
    }
  })
  module.hot.accept(() => {
    if (window.game) {
      const manager = window.game.scene
      const initialScene = LoadingScene.loadScenes(manager)
      manager.start(initialScene)
      console.log('Reloaded scenes:')
      manager.dump()
    }
  })
}
